import React, { useState } from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '../../../components/ui/alert-dialog';
import { fetchWithAuth } from '../../../utils/fetchWithAuth';
import { Loader2, AlertTriangle } from 'lucide-react';

export const UserDeleteDialog = ({ open, user, onClose, onUserDeleted }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleDeactivate = async () => {
    if (!user) return;

    setLoading(true);
    setError(null);

    try {
      const response = await fetchWithAuth(`/users/${user.id}`, {
        method: 'DELETE',
      });

      const json = await response.json();

      if (!response.ok) {
        throw new Error(json.error || 'Erreur lors de la désactivation de l\'utilisateur');
      }

      if (json.success) {
        onUserDeleted();
      } else {
        throw new Error(json.error || 'Erreur lors de la désactivation de l\'utilisateur');
      }
    } catch (err) {
      console.error('Error deactivating user:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  if (!user) return null;

  return (
    <AlertDialog open={open} onOpenChange={onClose}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <div className="flex items-center gap-2">
            <AlertTriangle className="h-5 w-5 text-amber-600" />
            <AlertDialogTitle>Confirmer la désactivation</AlertDialogTitle>
          </div>
          <AlertDialogDescription>
            Êtes-vous sûr de vouloir désactiver l'utilisateur <strong>{user.username}</strong> ({user.email}) ?
            <br />
            <br />
            L'utilisateur ne pourra plus se connecter. Vous pourrez le réactiver ultérieurement.
          </AlertDialogDescription>
        </AlertDialogHeader>

        {error && (
          <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded">
            {error}
          </div>
        )}

        <AlertDialogFooter>
          <AlertDialogCancel disabled={loading}>Annuler</AlertDialogCancel>
          <AlertDialogAction
            onClick={handleDeactivate}
            disabled={loading}
            className="bg-amber-600 hover:bg-amber-700"
          >
            {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
            Désactiver
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
